<template>
  <div
    class="pointer button-item-handler white--text no-decoration description" @click="showCalculationsHistory"
  >
    <app-icon name="clock" :size="18" />
    história
  </div>
</template>

<script>
import AppIcon from "@/components/shared/AppIcon.vue";

export default {
  name: "CalculationsHistoryHandler",
  components: { AppIcon },
  props: {
    rules: [Array, null],
    history: Object,
  },
  methods: {
    showCalculationsHistory () {
      this.$store.commit("popupManagerState/pushToPopupOrder", {
        type: null,
        payload: this.history,
        component: "CalculationsHistoryPopUp",
        rules: this.rules,
      });
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
